import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
} from '@angular/core';
import { Orcamento } from '../detail-expanded/detail-expanded.component';

@Component({
  selector: 'bs-table-cell-action',
  templateUrl: './table-cell-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTableCellActionComponent {
  @Input() data!: Orcamento;
  @Input() eventAction!: EventEmitter<Orcamento>;
}
